/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Inicio',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/landing-home',
        allowedRoles: ['admin', 'user', 'operator'],
    },
    {
        id  : 'divider-1',
        type: 'divider',
        allowedRoles: ['admin', 'supervisor'],
    },
    {
        id      : 'secutirty-features',
        title   : 'Configuraciones',
        subtitle: 'Configuraciones del sistema',
        type    : 'group',
        icon    : 'heroicons_outline:menu',
        allowedRoles: ['admin'],
        children: [
                {
                    id: 'products',
                    title: 'Productos',
                    type: 'basic',
                    icon: 'mat_outline:category',
                    link: '/products',
                    allowedRoles: ['admin'],
                },
                {
                    id: 'pacling',
                    title: 'Empaques',
                    type: 'basic',
                    icon: 'mat_outline:inventory',
                    link: '/packing',
                    allowedRoles: ['admin'],
                },
                {
                    id: 'companies',
                    title: 'Compañías',
                    type: 'basic',
                    icon: 'mat_outline:business',
                    link: '/companies',
                    allowedRoles: ['admin'],
                },
            ]
    },
    {
        id  : 'divider-1',
        type: 'divider',
        allowedRoles: ['admin', 'supervisor'],
    },
    {
        id      : 'secutirty-features',
        title   : 'Seguridad',
        subtitle: 'Administración de usuarios',
        type    : 'group',
        icon    : 'heroicons_outline:menu',
        allowedRoles: ['admin'],
        children: [     {
            id: 'users',
            title: 'Usuarios',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/users',
            allowedRoles: ['admin'],
        },]
    },
    {
        id  : 'divider-1',
        type: 'divider',
        allowedRoles: ['admin', 'supervisor'],
    },
    {
        id      : 'secutirty-features',
        title   : 'Contratos',
        subtitle: 'Administración de contratos',
        type    : 'group',
        icon    : 'heroicons_outline:menu',
        allowedRoles: ['admin'],
        children: [{
            id: 'users',
            title: 'Contratos',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/contracts',
            allowedRoles: ['admin'],
        },
        {
            id: 'contract-payments',
            title: 'Pagos de Contratos',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/payments',
            allowedRoles: ['admin'],
        }]
    }


    // {
    //     id: 'dynform',
    //     title: 'Dynamic Form',
    //     type: 'basic',
    //     icon: 'mat_outline:category',
    //     link: '/dynamicForm',
    //     allowedRoles: ['admin'],
    // },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
